// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documitra-partners-create {
  padding: 8px;
}
.documitra-partners-create .collapse1 {
  margin-bottom: 18px;
}
.documitra-partners-create .collapse1 .ant-collapse {
  overflow: hidden;
  border: 1px solid #e1e8f0;
  border-radius: 8px;
  background: #fff;
}
.documitra-partners-create .collapse1 .ant-collapse-header {
  min-height: 50px;
  padding: 14px 20px !important;
  color: #172033 !important;
  font-size: 15px;
  font-weight: 600;
  background: #f8fafc;
  align-items: center !important;
}
.documitra-partners-create .collapse1 .ant-collapse-content {
  border-top: 1px solid #e8eef4;
}
.documitra-partners-create .collapse1 .ant-collapse-content-box {
  padding: 0 !important;
}
.documitra-partners-create .ant-form-item {
  display: flex;
  align-items: flex-start;
  min-height: 76px;
  margin: 0 !important;
  padding: 16px 24px;
  border-bottom: 1px solid #e8eef4;
}
.documitra-partners-create .ant-form-item:last-child {
  border-bottom: 0;
}
.documitra-partners-create .ant-form-item > .ant-row {
  width: 100%;
}
.documitra-partners-create .ant-form-item .ant-form-item-label {
  flex: 0 0 22% !important;
  padding: 8px 20px 0 0 !important;
  text-align: left !important;
}
.documitra-partners-create .ant-form-item .ant-form-item-label > label {
  height: auto !important;
  color: #172033 !important;
  font-size: 15px !important;
  font-weight: 600;
  line-height: 22px;
}
.documitra-partners-create .ant-form-item .ant-form-item-control {
  flex: 1 1 !important;
  max-width: none !important;
  min-width: 0;
}
.documitra-partners-create .ant-form-item .ant-col-offset-4 {
  margin-left: 0 !important;
}
.documitra-partners-create .ant-form-item .ant-input,
.documitra-partners-create .ant-form-item .ant-input-number,
.documitra-partners-create .ant-form-item .ant-select-selector {
  width: 100% !important;
  min-height: 44px !important;
  border: 1px solid #ccd8e5 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #172033 !important;
  font-size: 15px;
}
.documitra-partners-create .ant-form-item .ant-input,
.documitra-partners-create .ant-form-item .ant-input-number-input {
  padding: 10px 14px;
}
.documitra-partners-create .ant-form-item .ant-select-single .ant-select-selector {
  display: flex;
  align-items: center;
  padding: 0 14px !important;
}
.documitra-partners-create .ant-form-item .ant-select-selection-placeholder,
.documitra-partners-create .ant-form-item .ant-input::placeholder {
  color: #7c96b5 !important;
  font-weight: 400;
}
.documitra-partners-create .ant-form-item .ant-input:hover,
.documitra-partners-create .ant-form-item .ant-input:focus,
.documitra-partners-create .ant-form-item .ant-input-focused,
.documitra-partners-create .ant-form-item .ant-input-number:hover,
.documitra-partners-create .ant-form-item .ant-input-number-focused,
.documitra-partners-create .ant-form-item .ant-select-focused .ant-select-selector,
.documitra-partners-create .ant-form-item .ant-select-selector:hover {
  border-color: #0b63ce !important;
  box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;
}
.documitra-partners-create .ant-form-item .ant-radio-wrapper {
  margin: 6px 20px 6px 0;
  color: #172033;
  font-size: 14px;
}
.documitra-partners-create .ant-form-item .ant-form-item-extra {
  margin-top: 6px;
  color: #60758d;
  line-height: 1.45;
}
.documitra-partners-create__actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 18px;
  padding: 14px 0 6px;
}

@media (max-width: 768px) {
  .documitra-partners-create {
    padding: 0;
  }
  .documitra-partners-create .collapse1 .ant-form-item {
    display: block;
    padding: 16px;
  }
  .documitra-partners-create .collapse1 .ant-form-item .ant-form-item-label {
    max-width: 100% !important;
    padding: 0 0 8px !important;
  }
  .documitra-partners-create__actions {
    flex-wrap: wrap;
    padding-inline: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/DocumitraPartners/DocumitraPartners.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACN;AAEI;EACE,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AAAN;AAGI;EACE,6BAAA;AADN;AAII;EACE,qBAAA;AAFN;AAME;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;AAJJ;AAMI;EACE,gBAAA;AAJN;AAOI;EACE,WAAA;AALN;AAQI;EACE,wBAAA;EAEA,gCAAA;EACA,2BAAA;AAPN;AASM;EACE,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AAWI;EACE,oBAAA;EACA,0BAAA;EACA,YAAA;AATN;AAYI;EACE,yBAAA;AAVN;AAaI;;;EAGE,sBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AAXN;AAcI;;EAEE,kBAAA;AAZN;AAeI;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAbN;AAgBI;;EAEE,yBAAA;EACA,gBAAA;AAdN;AAiBI;;;;;;;EAOE,gCAAA;EACA,wDAAA;AAfN;AAkBI;EACE,sBAAA;EACA,cAAA;EACA,eAAA;AAhBN;AAmBI;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAjBN;AAqBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE;IACE,UAAA;EApBF;EAsBE;IACE,cAAA;IACA,aAAA;EApBJ;EAsBI;IACE,0BAAA;IACA,2BAAA;EApBN;EAwBE;IACE,eAAA;IACA,mBAAA;EAtBJ;AACF","sourcesContent":[".documitra-partners-create {\n  padding: 8px;\n\n  .collapse1 {\n    margin-bottom: 18px;\n\n    .ant-collapse {\n      overflow: hidden;\n      border: 1px solid #e1e8f0;\n      border-radius: 8px;\n      background: #fff;\n    }\n\n    .ant-collapse-header {\n      min-height: 50px;\n      padding: 14px 20px !important;\n      color: #172033 !important;\n      font-size: 15px;\n      font-weight: 600;\n      background: #f8fafc;\n      align-items: center !important;\n    }\n\n    .ant-collapse-content {\n      border-top: 1px solid #e8eef4;\n    }\n\n    .ant-collapse-content-box {\n      padding: 0 !important;\n    }\n  }\n\n  .ant-form-item {\n    display: flex;\n    align-items: flex-start;\n    min-height: 76px;\n    margin: 0 !important;\n    padding: 16px 24px;\n    border-bottom: 1px solid #e8eef4;\n\n    &:last-child {\n      border-bottom: 0;\n    }\n\n    >.ant-row {\n      width: 100%;\n    }\n\n    .ant-form-item-label {\n      flex: 0 0 22% !important;\n\n      padding: 8px 20px 0 0 !important;\n      text-align: left !important;\n\n      >label {\n        height: auto !important;\n        color: #172033 !important;\n        font-size: 15px !important;\n        font-weight: 600;\n        line-height: 22px;\n      }\n    }\n\n    .ant-form-item-control {\n      flex: 1 1 0 !important;\n      max-width: none !important;\n      min-width: 0;\n    }\n\n    .ant-col-offset-4 {\n      margin-left: 0 !important;\n    }\n\n    .ant-input,\n    .ant-input-number,\n    .ant-select-selector {\n      width: 100% !important;\n      min-height: 44px !important;\n      border: 1px solid #ccd8e5 !important;\n      border-radius: 6px !important;\n      box-shadow: none !important;\n      color: #172033 !important;\n      font-size: 15px;\n    }\n\n    .ant-input,\n    .ant-input-number-input {\n      padding: 10px 14px;\n    }\n\n    .ant-select-single .ant-select-selector {\n      display: flex;\n      align-items: center;\n      padding: 0 14px !important;\n    }\n\n    .ant-select-selection-placeholder,\n    .ant-input::placeholder {\n      color: #7c96b5 !important;\n      font-weight: 400;\n    }\n\n    .ant-input:hover,\n    .ant-input:focus,\n    .ant-input-focused,\n    .ant-input-number:hover,\n    .ant-input-number-focused,\n    .ant-select-focused .ant-select-selector,\n    .ant-select-selector:hover {\n      border-color: #0b63ce !important;\n      box-shadow: 0 0 0 2px rgba(11, 99, 206, 0.08) !important;\n    }\n\n    .ant-radio-wrapper {\n      margin: 6px 20px 6px 0;\n      color: #172033;\n      font-size: 14px;\n    }\n\n    .ant-form-item-extra {\n      margin-top: 6px;\n      color: #60758d;\n      line-height: 1.45;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 18px;\n    padding: 14px 0 6px;\n  }\n}\n\n@media (max-width: 768px) {\n  .documitra-partners-create {\n    padding: 0;\n\n    .collapse1 .ant-form-item {\n      display: block;\n      padding: 16px;\n\n      .ant-form-item-label {\n        max-width: 100% !important;\n        padding: 0 0 8px !important;\n      }\n    }\n\n    &__actions {\n      flex-wrap: wrap;\n      padding-inline: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
